import * as HLF from "html-living-framework";
import {Ease} from "../Core/Animatable";
import {Container} from "../Core/Container";
import {Callback} from "../Core/Reflection";
import {Sprite} from "../Core/Sprite";
import {ButtonMute} from "../GameObjects/ButtonMute";
import {Keyboard} from "../GameObjects/Keyboard";
import {Rect} from "../Core/Shape";
import {Anchor} from "../Core/Anchor";

export class LoadScreen extends HLF.LoadScreen {

    public readonly main = this.addChild(new Container());
    public readonly rect = this.main.addChild(new Rect(3328, 1536, 0x9adfb3, 1, Anchor.middleCenter));
    public readonly loader = this.addChild(new Sprite());
    public readonly buttonMute = this.addChild(new ButtonMute());

    private _onLoaded?: Callback;
    private _isAnimatedIn = false;

    public init(pSize: PIXI.Point) {
        super.init(pSize);

        this._isAnimatedIn = false;
        this._onLoaded = undefined;

        this.loader.setLayoutTexture("loader", 0.5, 0.5);
        this.loader.rotation = 0;
        this.loader.scale.set(0.75);
        this.loader.changeParent(this.main);
        this.loader.killTweens();
        this.loader.scaleFrom(0, 0.2, Ease.sineOut, () => {
            this.loader.delayedCall(0.4, () => {
                this._isAnimatedIn = true;
                this.hideLoader();
            });
        });
        this.loader.tweenTo(0.8, Ease.none, {
            rotation: -Math.PI * 2,
            repeat: -1,
        });

        Keyboard.clear();
        Keyboard.enabled = true;
        Keyboard.add(this.buttonMute);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);

        if (this.buttonMute) {
            this.buttonMute.setPosition(this._size);
        }
    }

    public onLoadComplete(pCallback: () => void): void {
        this._onLoaded = pCallback;
        this.hideLoader();
    }

    private hideLoader() {
        if (this._isAnimatedIn && this._onLoaded) {
            this.loader.scaleTo(0, 0.2, Ease.sineIn, () => {
                this.loader.delayedCall(0.1, () => {
                    this.loader.killTweens();
                    this.callOnLoaded();
                });
            });
        }
    }

    private callOnLoaded() {
        if (this._onLoaded) {
            this.main.destroyChildren();
            this._onLoaded();
        }
    }
}
